var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"finish_tips"},[_vm._v("\n         密码已经修改成功，一定要保管好你的密码哦～\n     ")]),_vm._v(" "),_c('div',{staticClass:"login-link"},[_c('button',{staticClass:"btn_login",on:{"click":_vm.jumpLogin}},[_vm._v("立即登录")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602b768c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./module/forgetPassword/src/components/setSuccess.vue
// module id = cqgx
// module chunks = 1